<!--这是web的svg浏览组件,svg图只能放在static/svgFile路径下-->
<template>
  <div class="framediv" ref="maxwindow">
    <iframe class="iframe" ref="svgframe" id="svgframe" scrolling="auto" frameborder="0" marginheight="0"
      marginwidth="0"></iframe>

    <!-- 显示出实时曲线 -->
    <svgcurves ref="svgcurvesBean" :dialogVisible='dialogVisible' v-show="dialogVisible"
      @dialogVisible_fn="dialogVisible_fn" :deviceName="deviceName"></svgcurves>
  </div>
</template>
<script>
  import resourcesStore from '@/cache/resourcesStore.js'
  import svgcurves from '@/components/module/svg/svgCurves.vue';
  var ids,llines,rlines,offset=1000;
  export default {
    components: {
      svgcurves
    },
    props: ['svgpath'],
    data () {
      return {
        d: '/static/svgFile/设备箱系统2工况图.wdr.68.svg',
        b: '/static/svgFile/设备箱系统2接线图.wdr.11.svg',
        ids: [],
        nowScale: 50, //当前缩放倍率
        flag: false,//默认关闭滚轮事件,
        dialogVisible: false,
        deviceName: "",
        variableNameList: [],

      }
    },
    created () {
      debugPage=this
    },
    mounted () {

      var vue=this;

      var svgframe=this.$refs.svgframe
      svgframe.addEventListener('load',() => {
        this.resetSize()
        this.getNowIds();
        //获取svg内容对象
        var svg=svgframe.getSVGDocument().documentElement;
        // console.log("获取svg内容对象",svg);
        svg.addEventListener('DOMMouseScroll',wheel,false);
        svg.onmousewheel=document.onmousewheel=wheel;//W3C
        //统一处理滚轮滚动事件
        function wheel (event) {
          if(vue.flag) {
            var delta=0;
            if(!event) event=window.event;
            if(event.wheelDelta) {//IE、chrome浏览器使用的是wheelDelta，并且值为“正负120”
              delta=event.wheelDelta/120;
              if(window.opera) delta=-delta;//因为IE、chrome等向下滚动是负值，FF是正值，为了处理一致性，在此取反处理
            } else if(event.detail) {//FF浏览器使用的是detail,其值为“正负3”
              delta=-event.detail/3;
            }
            if(delta)
              handle(delta);
          }
        }

        function handle (delta) {
          if(delta<0) {//向下滚动  
            vue.nowScale>=2? vue.nowScale-=1:vue.nowScale=1;
          } else {//向上滚动 
            vue.nowScale<=299? vue.nowScale+=1:vue.nowScale=300
          }
        }
        //鼠标移入移出
        svg.onmouseover=function() {
          vue.flag=true
        }
        svg.onmouseout=function() {
          vue.flag=false
        }
      })
      addNewTask('webSvgRefreshData',0,3000,-1,() => {
        //定时刷新数据
        this.resetSize()
      })
      //刷新潮流线
      addNewTask('trendLine',0,100,-1,() => {
        this.trendLine()
      });
      setTimeout(() => {
        this.dialogDrag();
      },1000);
    },
    destroyed () {
      removeTask("webSvgRefreshData")
      removeTask("trendLine")
      this.realTimeValueStore.commit("removeKeys",this.ids)
      removeTask('refreshRealPowerQuality')
      this.realTimeValueStore.commit("removeKeys",this.variableNameList)
    },
    computed: {
      getResourcesByName () {
        return name => {
          return resourcesStore.getters.getResourcesByName(name)
        }
      },
      realTimeValueStore () {
        return this.$store.realTimeValueStore
      },
      valueList () {
        return this.realTimeValueStore.getters.getValue(this.ids)
      }
    },
    watch: {
      nowScale (nv,ov) {
        this.resetSize()
      },
      svgpath (nv,ov) {
        this.$refs.svgframe.contentWindow.location.replace(nv)
        this.nowScale=50;
        setTimeout(() => {
          this.dialogDrag();
        },1000);
      },
      ids (nv,ov) {
        this.realTimeValueStore.commit("removeKeys",ov)
        this.realTimeValueStore.commit("addKeys",nv)
      },
      valueList (nv,ov) {
        this.getMacRealValueCallback(nv)
        this.svgDataPage(nv)
        this.getPicSize()
      }
    },
    methods: {
      //曲线弹窗
      dialogVisible_fn (val) {
        this.dialogVisible=false

        //通用才需要
        this.variableNameList=val

      },
      // 弹窗拖拽属性
      dialogDrag () {

        const el=svgframe.getSVGDocument().documentElement;
        const el2=this.$refs.svgframe;
        const sty=(() => {
          return (dom,attr) => window.getComputedStyle(dom,'false')[attr];
        })();
        var lefted=0;
        var toped=0;

        el.onmousedown=(e) => {
          // console.log('可以拖动');
          lefted=el.scrollLeft;
          toped=el.scrollTop;
          // 鼠标按下，计算当前元素距离可视区的距离
          const disX=e.clientX;
          const disY=e.clientY;
          // alert(disX,disY)
          var iframe=document.querySelector('#svgframe').contentWindow
          var devicesHtml=iframe.document.elementFromPoint(disX,disY)
          //通用的
          // if(devicesHtml.getAttribute('DeviceNo')) {
          //   var arr=devicesHtml.getAttribute('DeviceNo').split('.')
          //   this.deviceName=arr[0]
          //   this.dialogVisible=true
          // }
          //天津德源定制版
          if(devicesHtml.getAttribute('DeviceNo')) {
            var arr=devicesHtml.getAttribute('DeviceNo')
            this.deviceName=arr
            this.variableNameList=[arr]
            this.dialogVisible=true
          }

          // 获取到的值带px 正则匹配替换
          var styL=sty(el,'left');
          let styT=sty(el,'top');

          var a;
          var b;
          // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
          if(styL.includes('%')) {
            a=+el2.clientWidth*(+styL.replace(/\%/g,'')/100);
            b=+el2.clientHeight*(+styT.replace(/\%/g,'')/100);

          } else {

            a=+styL.replace(/\px/g,'');
            b=+styT.replace(/\px/g,'');
          };
          styL=a;
          styT=b;
          el.onmousemove=function(e) {
            // 通过事件委托，计算移动的距离 
            let left=(disX-e.clientX);
            let top=(disY-e.clientY);
            // 移动当前元素  
            el.scrollTo(left+lefted,top+toped);
          };

          el.onmouseup=function(e) {
            el.onmousemove=null;
            el.onmouseup=null;
          };
        }

      },
      //判断滚动方向，因为此demo中只有四页，故边界处理为 0 与 3
      handleScroll (e) {
        let direction=e.deltaY>0? 'down':'up';  //deltaY为正则滚轮向下，为负滚轮向上
        if(direction=='down'&&e.deltaY>=125) { //125为用户一次滚动鼠标的wheelDelta的值
          if(this.initialIndex>=3) {
            this.initialIndex=3
          } else {
            this.initialIndex+=1;
            this.setActiveItem(this.initialIndex)
          }
        }
        if(direction=='up'&&e.deltaY<=-125) {
          if(this.initialIndex<=0) {
            this.initialIndex=0;
            // this.setActiveItem(0)
          } else {
            this.initialIndex-=1;
            this.setActiveItem(this.initialIndex)
          }
        }
      },
      getNowIds () {
        //获取当前变量列表
        var svgframe=this.$refs.svgframe
        if(svgframe==undefined||svgframe.getSVGDocument()==undefined) {
          return
        }
        //获取svg内容对象
        var svg=svgframe.getSVGDocument().documentElement
        //重新获取IDS
        var ids=[]
        var devices=svg.getElementsByTagName('text')
        for(var i=0;i<devices.length;i++) {
          var item=devices[i].getAttribute('DeviceNo')
          if(!isempty(item)) {
            ids.push(item)
          }
        }
        var uses=svg.getElementsByTagName('use')
        for(var i=0;i<uses.length;i++) {
          var item=uses[i].getAttribute('DeviceNo')
          if(!isempty(item)) {
            ids.push(item)
          }
        }
        this.ids=ids
      },
      resetSize () {
        //缩放到指定倍率大小
        var svgframe=this.$refs.svgframe
        if(svgframe==undefined||svgframe.getSVGDocument()==undefined) {
          return
        }
        //获取svg内容对象
        var svg=svgframe.getSVGDocument().documentElement;
        svg.style.overflow='hidden'
        //调整viewbox至刚好显示全屏
        svg.setAttribute("width",svgframe.offsetWidth*(this.nowScale/50)-2)
        svg.setAttribute("height",svgframe.offsetHeight*(this.nowScale/50)-2)
      },
      getMacRealValueCallback (values) {
        var doc=this.$refs.svgframe.getSVGDocument().getElementsByTagName("svg")[0]
        var devices=doc.getElementsByTagName('text')
        var uses=doc.getElementsByTagName('use')
        this.ids.forEach((item,index) => {
          var value=values[index]
          if(value!=undefined) {
            value=value.split(':')[0]
          }
          if(value==undefined) {
            return
          }
          //找到元素,赋值
          for(var i=0;i<devices.length;i++) {
            if(devices[i].getAttribute('DeviceNo')==item) {
              var fm=devices[i].getAttribute("format");
              if(isempty(fm)) {
                fm="#0.00"
              }
              //一般是#0.00这样的，有时候会加单位在后面，我们要把#0.00部分其替换成值
              if(fm.indexOf("#0.")!=-1) {
                var len=fm.length-3
                for(var j=0;j<fm.length-3;j++) {
                  if(fm.charAt(j+3)!='0') {
                    len=j
                    break
                  }
                }
                fm=fm.substring(len+3)
                value=parseFloat(value).toFixed(len)+fm
              }
              devices[i].textContent=isempty(value)? "--":value
            }
          }
          for(var i=0;i<uses.length;i++) {
            if(uses[i].getAttribute('DeviceNo')==item) {
              //样式，不为0就在后面加上状态
              var link=uses[i].getAttribute("xlink:href")
              //缓存的上一次状态
              var state=uses[i].getAttribute("state")
              if(state!=0) {
                //移除一下原来的样式
                link=link.substring(0,link.lastIndexOf(state))
              }
              var newState=parseInt(value)
              //刷新图符样式
              if(newState!=0) {
                link=link+newState
              }
              uses[i].setAttribute("xlink:href",link)
              uses[i].setAttribute("state",newState)
            }
          }
        })
      },
      svgDataPage (values) {
        //获取所有的图元方法
        var doc=this.$refs.svgframe.getSVGDocument().getElementsByTagName("svg")[0]
        var textValue=doc.getElementsByTagName('text')
        var value='' //获取到的实时值
        let valueList=[]
        let ids=this.distinct(copy(this.ids))
      },
      //获取图形大小
      getPicSize () {
        var doc=this.$refs.svgframe.getSVGDocument().getElementsByTagName("svg")[0]
        var devices=doc.getElementsByTagName('rect')
        let width=devices[0].width.animVal.value
        let height=devices[0].height.animVal.value
        this.$emit('widthAndHeight',width,height)
      },
      distinct (arr) {
        //数组去重
        let newArr=[]
        for(let i=0;i<arr.length;i++) {
          if(!newArr.includes(arr[i])) {
            newArr.push(arr[i])
          }
        }
        return newArr
      },
      trendLine () {
        if(offset<=0) offset=1000;
        //if (isempty(llines) || llines.length == 0) {
        llines=$('#svgframe').contents().find("g polyline[class='leftdash']");
        //}
        llines.each(function() {
          this.style.strokeDashoffset=offset;
        });
        //if (isempty(rlines) || rlines.length == 0) {
        rlines=$('#svgframe').contents().find("g polyline[class='rightdash']");
        //}
        rlines.each(function() {
          this.style.strokeDashoffset=1000-offset;
        });
        offset=offset-2;
      }
    }
  }
</script>
<style>
  .zoonContainer .el-button {
    padding: 0;
  }

  .zoonContainer .el-button--primary.is-plain {
    background: rgba(0, 0, 0, 0);
    border-color: rgba(0, 0, 0, 0);
    color: #409EFF;
  }

  .zoonContainer .el-button--primary.is-plain:focus,
  .el-button--primary.is-plain:hover {
    color: #105caa;
  }

  .zoonContainer .el-button span {
    font-size: 30px;
    font-weight: 900;
  }
</style>
<style scoped>
  .iframe {
    width: 100%;
    height: 100%;
  }

  .iframe svg {
    background: red !important;
  }

  .rotate {
    position: absolute;
    transform: rotate(90deg);
  }

  .framediv {
    overflow: hidden;
    position: relative;
  }

  .zoonContainer {
    position: absolute;
    width: 40px;
    right: 80px;
    top: 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .zoonContainer>div {}

  .zoon {
    cursor: pointer;
    width: 30px;
    padding: 5px;
    height: 30px;
    box-shadow: 0 0 5px silver;
  }

  .zoonOut {
    margin-top: 10px;
  }
</style>